
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `var d=document,w="https://tally.so/widgets/embed.js",v=function(){"undefined"!=typeof Tally?Tally.loadEmbeds():d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((function(e){e.src=e.dataset.tallySrc}))};if("undefined"!=typeof Tally)v();else if(d.querySelector('script[src="'+w+'"]')==null){var s=d.createElement("script");s.src=w,s.onload=v,s.onerror=v,d.body.appendChild(s);}`;
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#B8985F]/10 mb-5">
              <div className="w-2 h-2 rounded-full bg-[#B8985F] animate-pulse"></div>
              <span className="text-[12px] tracking-[1.5px] uppercase text-[#B8985F] font-semibold">
                Get in Touch
              </span>
            </div>
            <h2 className="text-[32px] md:text-[44px] font-bold text-[#1A1A1A] mb-4 leading-[1.15]">
              Ready to reduce ticket volume?
            </h2>
            <p className="text-[15px] md:text-[16px] text-[#777] mb-8 leading-[1.7]">
              Book a call or send us a message. We&apos;ll show you how AI agents can cut your support costs and improve customer satisfaction.
            </p>

            <Link
              to="/book-a-call"
              className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#B8985F] text-white text-[14px] font-semibold rounded-lg hover:bg-[#A07D4A] transition-all duration-300 shadow-[0_4px_16px_rgba(184,152,95,0.25)] hover:shadow-[0_6px_24px_rgba(184,152,95,0.35)] hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
              Book a Call
            </Link>

            <div className="mt-10 space-y-4">
              {[
                { icon: 'ri-time-line', text: '30-minute strategy session' },
                { icon: 'ri-shield-check-line', text: 'No commitment required' },
                { icon: 'ri-bar-chart-box-line', text: 'Custom volume reduction estimate' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-[#B8985F]/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#B8985F] text-sm`}></i>
                  </div>
                  <p className="text-[14px] text-[#555]">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#FAFAF8] rounded-xl border border-[#F0EDE6] p-6 md:p-8">
            <h3 className="text-[24px] md:text-[28px] font-bold text-[#1A1A1A] mb-6">
              Contact Us
            </h3>
            <iframe
              data-tally-src="https://tally.so/embed/ODzNK7?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="542"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              title="Contact Us"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
